/* eslint-disable no-use-before-define */

const URL_SIGNAUX_DOCUMENTAIRES = '/projections-documentaires/signaux.json';
const DUREE_CACHE_MS = 5 * 60 * 1000;

let cacheSignaux = null;
let cacheExpireA = 0;
let chargementEnCours = null;

export const chargerSignauxDocumentaires = async () => {
  const maintenant = Date.now();
  if (cacheSignaux && maintenant < cacheExpireA) return cacheSignaux;
  if (chargementEnCours) return chargementEnCours;

  chargementEnCours = fetch(URL_SIGNAUX_DOCUMENTAIRES, { method: 'GET' })
    .then((reponse) => {
      if (!reponse.ok) throw new Error('HTTP ' + reponse.status + ' ' + reponse.statusText);
      return reponse.json();
    })
    .then((payload) => {
      cacheSignaux = construireIndexSignaux(payload);
      cacheExpireA = Date.now() + DUREE_CACHE_MS;
      chargementEnCours = null;
      return cacheSignaux;
    })
    .catch((erreur) => {
      chargementEnCours = null;
      throw erreur;
    });

  return chargementEnCours;
};

export const creerIndexSignauxVide = () => construireIndexSignaux(null);

export const trouverSignalParIdDocumentaire = (index, idDocumentaire) => {
  if (!index || !idDocumentaire) return null;
  return index.parId[normaliserCleSignal(idDocumentaire)] || null;
};

export const trouverSignalParNom = (index, nomSignal) => {
  if (!index || !nomSignal) return null;
  const nomNormalise = normaliserCleSignal(nomSignal);
  return index.parNom[nomNormalise] || index.parId[nomNormalise] || null;
};

export const trouverSignalDansTexte = (index, valeur) => {
  if (!index || !valeur) return null;
  const texte = normaliserCleSignal(valeur);
  if (!texte) return null;

  const direct = trouverSignalParNom(index, texte);
  if (direct) return direct;

  const match = index.alias
    .filter((alias) => alias.cle && texte.includes(alias.cle))
    .sort((a, b) => b.cle.length - a.cle.length)[0];
  return match ? match.signal : null;
};

export const listerSignauxReconnus = (index, valeurs) => {
  const reconnus = new Map();
  (valeurs || []).forEach((valeur) => {
    const signal = trouverSignalDansTexte(index, valeur);
    if (signal) reconnus.set(signal.id, signal);
  });
  return Array.from(reconnus.values()).sort((a, b) => String(a.nom).localeCompare(String(b.nom), 'fr'));
};

const construireIndexSignaux = (payload) => {
  const signaux = payload && payload.signaux ? Object.values(payload.signaux) : [];
  const index = {
    signaux,
    parId: {},
    parNom: {},
    alias: [],
    genereLe: payload && payload.projection ? payload.projection.genere_le : '',
  };

  signaux.forEach((signal) => {
    const id = normaliserCleSignal(signal.id);
    const nom = normaliserCleSignal(signal.nom);
    if (id) index.parId[id] = signal;
    if (nom) index.parNom[nom] = signal;

    aliasesSignal(signal).forEach((alias) => {
      const cle = normaliserCleSignal(alias);
      if (!cle) return;
      if (!index.parNom[cle]) index.parNom[cle] = signal;
      index.alias.push({ cle, signal });
    });
  });

  index.alias.sort((a, b) => b.cle.length - a.cle.length);
  return index;
};

const aliasesSignal = (signal) => {
  const valeurs = [signal.id, signal.nom];
  String(signal.nom || '').split('/').forEach((partie) => valeurs.push(partie));
  return valeurs.map((valeur) => String(valeur || '').replace(/`/g, '').trim()).filter(Boolean);
};

const normaliserCleSignal = (valeur) => String(valeur || '')
  .replace(/`/g, '')
  .trim()
  .toUpperCase();



// WEBPACK FOOTER //
// src/components/cockpit/signauxDocumentairesService.js